// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React, {useContext} from 'react';
import {Settings_context} from '../../../../hola/pub/settings_ctx';
import {useHistory} from 'react-router-dom';
import cn from 'classnames';
import styles from './category_badge.module.less';

interface i_category_badge_props {
    category: string;
    on_click?: (category: string)=>void;
}

export const Category_badge = (props: i_category_badge_props)=>{
    const {theme} = useContext(Settings_context);
    const history = useHistory();
    const formatted_category =
        props.category.replace(/\s+/g, '-').toLowerCase();
    const handle_click = e=>{
        e.stopPropagation();
        if (props.on_click)
            props.on_click(props.category);
        history.push(`/blog/${formatted_category}`);
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };
    return <div className={styles.category_badge} onClick={handle_click}>
      <p className={cn(theme.p12, theme.med)}>{props.category}</p>
    </div>;
};
